import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import { scrollTop } from '@/helpers/scroll';

import AdvisorSearchRequestPage from '@/modules/advisor-search/pages/AdvisorSearchRequestPage.vue';
import AdvisorSearchUsersPage from '@/modules/advisor-search/pages/AdvisorSearchUsersPage.vue';

const BASE_URL = '/topics';

export const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => {
    const MAX_SCROLL_HEIGHT = 100;
    if (window.scrollY >= MAX_SCROLL_HEIGHT) {
      window.scrollTo(0, MAX_SCROLL_HEIGHT);
      scrollTop(0);
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes: [
    {
      path: BASE_URL,
      component: Vue.extend({
        name: 'AdvisorSearchRouterSwitcher',
        inheritAttrs: false,
        render(h) {
          const isSearch = this.$route.query.keyword !== undefined;
          return h(
            isSearch ? AdvisorSearchUsersPage : AdvisorSearchRequestPage,
            {
              props: this.$attrs,
            },
          );
        },
      }),
    },
    {
      path: '*',
      redirect: BASE_URL,
    },
  ],
});
